<template>
  <v-app>
    <v-main>
      <v-container
        class="fill-height"
        fluid
        style="background-image: url('Calcjud.jpg');background-size: cover; "
      >
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12">
              <slot></slot>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "LayoutLogin",
  props: {},
  data: () => ({
    drawer: null
  }),
  created() {
    let usuarioAux = sessionStorage.getItem("usuario");
    if (usuarioAux) {
      this.usuario = JSON.parse(usuarioAux);
      this.$router.push("/#");
    }
  }
};
</script>


